import { render, staticRenderFns } from "./WizardThree.vue?vue&type=template&id=4f03574e"
import script from "./WizardThree.vue?vue&type=script&lang=ts"
export * from "./WizardThree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports